import type { TFilterNavigationState, TNavigationType, TPageKey, TPendingTransfer, TSavedPageFilters } from './types';

export const getLastNavigationType = (state: TFilterNavigationState): TNavigationType | null =>
  state.lastNavigationType;

export const getPendingTransfer = (state: TFilterNavigationState): TPendingTransfer | null => state.pendingTransfer;

export const getSavedFilters = (state: TFilterNavigationState): Partial<Record<TPageKey, TSavedPageFilters | null>> =>
  state.savedFilters;

export const getRouteHistory = (state: TFilterNavigationState): string[] => state.routeHistory;
